<template>
    <reconciliation-step-template 
        :nextStep="nextStep" 
        :previousStep="previousStep" 
        @next="goToNextStep"
        @previous="$emit('previous')">
        
        <template slot="content">
        
            <h3>{{ $l10n.__("Montant de la transaction") }}</h3>
            <p class="fs-3 semibold mt-4 mb-2">{{ $l10n.__("Sélectionnez le type d’affichage que vous rencontrez et définissez le type de la colonne montant.") }}</p>
            <custom-radio-group>
                <custom-radio-item 
                    v-for="(amountType, amountTypeIndex) in amountTypes" 
                    :key="amountTypeIndex"
                    :data="amountType"
                    v-model="value.template.amountType"
                    @input="resetSelectedColumns">
                        <div class="circle"></div>
                        <div class="illu mt-3">
                            <img :src="`/ressources/logged/img/bankreconciliation/${amountType.value}.png`" alt="" />
                        </div>
                        <p class="fs-3 gray-80">{{ amountType.label }}</p>
                    </custom-radio-item>
            </custom-radio-group>

            <div class="mt-3">
                <p class="fs-3 gray-80 mt-4 mb-2">{{activeAmountType.info}}</p>
                <p class="fs-3 semibold mt-4 mb-2">
                    {{ $l10n.__("Sélectionnez la colonne puis cliquez sur continuer.") }}
                </p>

                <div class="step-container-table border-black">
                    <table-selectable-columns 
                        :lines="csv"
                        v-model="selectedColumns"
                        :max="1"
                    />
                </div>
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
    import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue'
    import ImportStepsMixins from './ImportStepsMixins'
    import SelectInput from 'vcomponents/inputs/SelectInput.vue'
    import CustomRadioGroup from 'vcomponents/utilities/CustomRadioGroup.vue'
    import CustomRadioItem from 'vcomponents/utilities/CustomRadioItem.vue'


    export default {
        mixins: [ImportStepsMixins],
        data(){
            return {
                selectedColumns: [],
                amountTypes: [
                    {
                        label: this.$l10n.__('Crédit/débit sur une colonne'),
                        value: '1col',
                        forceRoute: false,
                        key: 'amount_with_type',
                        info: this.$l10n.__("Crédit et débit avec type : Si votre colonne contient des chiffres avec des indicatifs positifs et négatifs. (Ex: + 36.89€)"),
                    },
                    {
                        label: this.$l10n.__('Crédit/débit sur deux colonnes'),
                        value: '2col',
                        forceRoute: 'bankreconciliation-step3-2',
                        key: 'amount_credit',
                        info: this.$l10n.__("Crédit / débit : Si votre fichier comporte une colonne pour les crédits et une autre colonne pour les débits. Sélectionnez tout d’abord la colonne Crédits : "),
                    },
                    {
                        label: this.$l10n.__('Type transaction séparé'),
                        value: 'colWithoutType',
                        forceRoute: 'bankreconciliation-step3-1',
                        key: 'amount',
                        info: this.$l10n.__("Crédit et débit sans type : Si votre colonne contient uniquement des chiffres sans type indicatif. (Ex: 36.89€) Et une autre colonne avec le type Crédit ou Débit."),
                    },
                ],
            }
        },
        created(){
            this.checkPreviousSteps()
        },
        mounted(){
            this.setColumns()
        },
        computed: {
            activeAmountType(){
                return this.amountTypes.find(amountType => amountType.value == this.value.template.amountType)
            }
        },
        methods: {
            resetSelectedColumns(){
                this.value.template.amount_with_type.columns = []
                this.value.template.amount.columns = []
                this.value.template.amount_credit.columns = []
                this.selectedColumns = []
            },
            goToNextStep(){
                this.formatData()
                this.$emit('input', this.value)
                if(this.checkColumnsByAmountType()){
                    let forcedRoute = this.amountTypes.find(type => type.value == this.value.template.amountType).forceRoute
                    this.$emit('next', forcedRoute ? forcedRoute : false)
                }
            },
            checkColumnsByAmountType(){
                return this.checkMinColumns(this.activeAmountType.key, 1) ? true : false
            },
            formatData(){
                this.value.template[this.activeAmountType.key].columns = this.selectedColumns
            },
            setColumns(){
                if(this.value.template[this.activeAmountType.key].columns.length > 0){
                    this.value.template[this.activeAmountType.key].columns.map(value => this.selectedColumns.push(value))
                }
            }
        },
        components: {
            TableSelectableColumns,
            SelectInput,
            CustomRadioGroup,
            CustomRadioItem
        }
    }
</script>

<style scoped>

</style>
